import { getSavedAuthData } from './auth-helpers';
import { LoginTypes } from './types';
import useAuthStore from './useAuthStore';

// Saved identity is a display hint only. Authorization always uses the real account.
const useAccountRestoration = () => {
    const { account, isLoginPending, isSessionRestorePending, loginErrorText } = useAuthStore();
    const saved = getSavedAuthData();
    const hasSavedAccount = Boolean(
        saved.pubKey && saved.loginType && saved.loginType !== LoginTypes.secret,
    );
    const isRestoring =
        !account &&
        Boolean(
            isLoginPending || (isSessionRestorePending ?? (hasSavedAccount && !loginErrorText)),
        );
    return {
        isRestoring,
        savedAccount: isRestoring && hasSavedAccount ? saved : null,
        hasAccountLayout: Boolean(account || isRestoring),
    };
};

export default useAccountRestoration;
